import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	leaseProcessCode: '',
	glAssignmented: false,
	ccAssignmented: false,
	maxRecordedDate: {
		leaseId: '',
		minimumDateLimit: '',
	},
};

const leaseSlice = createSlice({
	name: 'lease',
	initialState,
	reducers: {
		setLeaseProcessCode(state, action) {
			state.leaseProcessCode = action.payload;
		},
		setGlAssignmented(state, action) {
			state.glAssignmented = action.payload;
		},
		setCcAssignmented(state, action) {
			state.ccAssignmented = action.payload;
		},
		setMaxRecordedDate(state, action) {
			state.maxRecordedDate = {
				leaseId: action.payload.leaseId,
				minimumDateLimit: action.payload.minimumDateLimit,
			};
		},
	},
});

export const { setLeaseProcessCode, setCcAssignmented, setGlAssignmented, setMaxRecordedDate } = leaseSlice.actions;
export default leaseSlice.reducer;
